import { API_URL, APP_URL } from './config.js'

/**
 * Generate headers
 * @param language {String}
 * @returns {Object}
 */
const getJSONHeaders = (language = 'en') => ({
  'Content-type': 'application/json',
  Accept: 'application/json',
  'Content-language': language,
})

export const calls = {
  getFabrics: (filters, CancelToken, dispatch) => ({
    url: `${API_URL}/products?category=25&${filters}`,
    method: 'GET',
    headers: getJSONHeaders(),
    cancelToken: new CancelToken((cancel) => {
      dispatch({ type: 'SET_CANCEL', payload: { cancel } })
    }),
  }),
  getProductById: (id) => ({
    url: `${API_URL}/products/${id}`,
    method: 'GET',
    headers: getJSONHeaders(),
  }),
  getFabrictById: (id) => ({
    url: `${API_URL}/products/${id}`,
    method: 'GET',
    headers: getJSONHeaders(),
  }),
  getMoreFabrics: (filters) => ({
    url: `${API_URL}/products?category=25&${filters}`,
    method: 'GET',
    headers: getJSONHeaders(),
  }),
  getWestchaseFabrics: (filters) => ({
    url: `${API_URL}/products?category=25&${filters}`,
    method: 'GET',
    headers: getJSONHeaders(),
  }),
  getAllFabricsWithAllProperties: (page) => ({
    // this is only for rare cases! (e.g. when we need to get all fabrics because we can't find it in fabrics.fabrics)
    url: `${API_URL}/products?category=25&per_page=100&page=${page}`,
    method: 'GET',
    headers: getJSONHeaders(),
  }),
  getMaterials: () => ({
    url: `${API_URL}/materials`,
    method: 'GET',
    headers: getJSONHeaders(),
  }),
  getBrands: () => ({
    url: `${API_URL}/brands`,
    method: 'GET',
    headers: getJSONHeaders(),
  }),
  getUses: () => ({
    url: `${API_URL}/products/attributes/8/terms?per_page=100&page=1`,
    method: 'GET',
    headers: getJSONHeaders(),
  }),
  getPatterns: () => ({
    url: `${API_URL}/products/attributes/7/terms?per_page=100&page=1`,
    method: 'GET',
    headers: getJSONHeaders(),
  }),
  getColorMap: () => ({
    url: `${API_URL}/colors`,
    method: 'GET',
    headers: getJSONHeaders(),
  }),
  getCushionsByCategory: (categoryId) => ({
    method: 'GET',
    url: `${API_URL}/products?category=${categoryId}`,
    headers: getJSONHeaders('en'),
  }),
  getAttributeTermsById: (attributeId) => ({
    method: 'GET',
    url: `${API_URL}/products/attributes/${attributeId}/terms?per_page=100&page=1`,
    headers: getJSONHeaders('en'),
  }),
  getAllFabrics: () => ({
    method: 'GET',
    url: `${API_URL}/all_fabrics`,
    headers: getJSONHeaders(),
  }),
  getProductsDeepSeat: () => ({
    method: 'GET',
    url: `${API_URL}/products?category=28`,
    headers: getJSONHeaders(),
  }),
  getProductsPillow: () => ({
    method: 'GET',
    url: `${API_URL}/products?category=27`,
    headers: getJSONHeaders(),
  }),
  getProductsCushion: () => ({
    method: 'GET',
    url: `${API_URL}/products?category=769`,
    headers: getJSONHeaders(),
  }),
  getKits: (userid) => ({
    method: 'GET',
    url: `${API_URL}/kits/${userid}`,
    headers: getJSONHeaders(),
  }),
  getUserId: () => ({
    method: 'GET',
    url: `${API_URL}/myuserid`,
    headers: getJSONHeaders(),
  }),
  getPrice: (params) => ({
    method: 'GET',
    url: `${API_URL}/get_price${params}`,
    headers: getJSONHeaders(),
  }),
  deleteItemFromCart: (itemId, _wpnonce) => ({
    method: 'DELETE',
    url: `${APP_URL}/cart/?remove_item=${itemId}&_wpnonce=${_wpnonce}`,
    headers: getJSONHeaders(),
  }),
}
